import { split, calculate } from '../utils/split';

export default class ParagraphAnimation {
	constructor({ element }) {
		const paragraphs = element.querySelectorAll(
			'h1, h2, h3, h4, h5, h6, li, p'
		);
		console.log(paragraphs);
		this.allSpans = [];

		if (paragraphs.length) {
			console.log(paragraphs);
			paragraphs.forEach((paragraph) => {
				// Split each paragraph into word spans
				const wordSpans = split({
					element: paragraph,
					expression: ' ',
				});

				// Wrap each span in another span for overflow clipping
				this.wrapSpansForReveal(wordSpans);

				// Calculate line positions (after wrapping)
				const wrappedSpans = paragraph.querySelectorAll('span > span');
				const lines = calculate(wrappedSpans);

				// Store for animation
				this.allSpans.push(...wrappedSpans);
			});
		} else {
			// Single element
			const wordSpans = split({ element });
			this.wrapSpansForReveal(wordSpans);

			const wrappedSpans = element.querySelectorAll('span > span');
			this.allSpans.push(...wrappedSpans);
		}

		// Set initial state: hidden below
		this.setInitialState();
	}

	wrapSpansForReveal(spans) {
		// Wrap each word span in another span for overflow clipping
		spans.forEach((span) => {
			const wrapper = document.createElement('span');
			wrapper.style.display = 'inline-block';
			wrapper.style.overflow = 'hidden';
			wrapper.style.verticalAlign = 'bottom';

			// Clone the original span
			const inner = span.cloneNode(true);
			inner.style.display = 'inline-block';

			// Replace original with wrapped version
			span.parentNode.replaceChild(wrapper, span);
			wrapper.appendChild(inner);
		});
	}

	setInitialState() {
		// Set all spans to start position (hidden)
		this.allSpans.forEach((span) => {
			span.style.transform = 'translateY(110%)';
		});
	}

	animateIn() {
		// Calculate lines from current spans
		const lines = this.calculateLines();

		lines.forEach((lineWords, lineIndex) => {
			lineWords.forEach((span) => {
				span.style.transform = 'translateY(0%) rotate(0)';
				span.style.transition = `transform 1.66s ${
					0.1 + lineIndex * 0.1
				}s var(--ease-out-expo)`;
			});
		});
	}

	animateOut() {
		let rotation = 0;
		const lines = this.calculateLines();

		lines.forEach((lineWords) => {
			lineWords.forEach((span) => {
				rotation += 1;
				span.style.transform = `translateY(150%) rotate(${rotation}deg)`;
				span.style.transition = '';
			});
		});
	}

	calculateLines() {
		return calculate(this.allSpans);
	}
}
